
import React from 'react';

export const XMarkIcon: React.FC<{ className?: string }> = ({ className }) => (
  <span className={`material-symbols-outlined ${className}`}>
    close
  </span>
);